import React, { SyntheticEvent, useState } from "react";

import { Link } from "@at/design-system-elements";
import { TypeSmart } from "@at/design-system-foundation";
import { Modal, ModalVariant } from "@at/design-system-patterns";
import { dataAttrGUI } from "@at/formatter-utils/lib/data-attr-utils/data-attr-utils";

import { getDataGuiPrefixedValue } from "../../../../utils/deal-builder/deal-builder.utils";
import { useTracking } from "../../../../utils/tracking/use-tracking";
import { PublicChargingInfo } from "../public-charging-info";

export const PublicChargingExplainedModal = () => {
  const [visible, setVisible] = useState(false);
  const { trackEvent, trackModalEvent } = useTracking();
  return (
    <>
      <TypeSmart as="span" weight="400">
        <Link
          href={`#PublicChargingExplained`}
          routerLink={false}
          onInteraction={(e: SyntheticEvent) => {
            e.preventDefault();
            setVisible(true);
          }}
          attributes={{
            [dataAttrGUI]: getDataGuiPrefixedValue("Public-charging-explained"),
            "aria-label": "read how public charging is explained",
          }}
          trackingCallback={() =>
            trackEvent({
              trackingLabel: "electric-public-charging-explained",
            })
          }
        >
          Public charging explained
        </Link>
      </TypeSmart>

      <Modal
        isShowing={visible}
        hasBackLink={false}
        closeText="Back"
        variation={ModalVariant.SLIDE}
        hideFn={() => setVisible(false)}
        trackingCallback={({ modalAction }) => {
          trackModalEvent({
            trackingLabel: "public-charging-explained-modal",
            modalAction,
          });
        }}
      >
        <PublicChargingInfo />
      </Modal>
    </>
  );
};
